import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdministrativeAccessService } from '../services/administrative-access.service';
import { localReturnPath } from '../config/runtime-config';

export const administrativePageGuard: CanActivateFn = (_, state) => {
  const access = inject(AdministrativeAccessService);
  return (
    access.canEnter() ||
    inject(Router).createUrlTree(['/administration-required'], {
      queryParams: { returnPath: state.url },
    })
  );
};

export const administrativeHomeGuard: CanActivateFn = (_, state) => {
  const first = inject(AdministrativeAccessService).firstPage();
  const router = inject(Router);
  return first
    ? router.parseUrl(first)
    : router.createUrlTree(['/administration-required'], {
        queryParams: { returnPath: state.url },
      });
};

export const administrativeExplanationGuard: CanActivateFn = (route) => {
  const access = inject(AdministrativeAccessService);
  if (!access.canEnter()) return true;
  const target = localReturnPath(
    route.queryParamMap.get('returnPath'),
    location.origin,
  );
  return inject(Router).parseUrl(
    target && access.canOpen(target.split(/[?#]/, 1)[0])
      ? target
      : (access.firstPage() ?? '/access-admin'),
  );
};
